export default __webpack_public_path__ + "7010b77a68457393de497b561a8b2d88.png";